module.exports = __webpack_public_path__ + "static/img/banner5.43ea569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner5.jpg
// module id = eHCA
// module chunks = 0